export enum PaymentProvider {
  PAGARME = 'PAGARME',
  IUGU = 'IUGU',
}
